import { useMotionValue, animate } from 'framer-motion'
import { useEffect, useState } from 'react'

interface StatValueProps {
  value: number
  className?: string
}

export function StatValue({ value, className = '' }: StatValueProps) {
  const [display, setDisplay] = useState(0)
  const motionVal = useMotionValue(0)

  useEffect(() => {
    const controls = animate(motionVal, value, {
      duration: 2,
      ease: 'easeOut',
      onUpdate: (v) => setDisplay(Math.round(v)),
    })
    return controls.stop
  }, [value, motionVal])

  return <span className={className}>{display.toLocaleString()}</span>
}
